import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { getRemoteLocalStorage } from '@confluence/storage-manager/entry-points/getRemoteLocalStorage';

export async function preloadLocalStorage() {
	const { userId, isLicensed } = getPreloaderFnContext();
	return getRemoteLocalStorage({
		userId,
		isLicensed,
	});
}
